export const portfolioEn = {
	portfolio: {
		nav: {
			ariaLabel: 'Main navigation',
			contact: 'Contact',
			experience: 'Experience',
			home: 'Home',
			projects: 'Projects',
			skills: 'Skills',
		},
		section: {
			aiIndicator: {
				ariaLabel: 'AI-assisted development',
				feature: {
					agents: 'Agents',
					hooks: 'Hooks',
					plans: 'Plans',
					skills: 'Skills',
				},
				info: {
					experience: '5 Years',
					experienceSubtext: 'Full-stack',
					location: 'Bordeaux, France',
					locationSubtext: 'Remote OK',
					role: 'Lead Developer',
					roleSubtext: '@ Orange Business',
				},
				tagline: 'I architect, AI executes, I validate',
				tech: ['React', 'TypeScript', 'Rust', 'Kubernetes', 'AI', 'Ubuntu'],
				title: 'Peer programming with Claude Code',
			},
			contact: {
				ariaLabel: 'Contact',
				placeholder: 'Contact section coming soon...',
				title: 'Contact',
			},
			experience: {
				ariaLabel: 'Professional Experience',
				badge: {
					leadDev: 'Lead Dev',
				},
				description: {
					liveIntelligence:
						"Building a unified administration portal for Live Intelligence, Orange's enterprise generative AI platform. Consolidating fragmented tooling into a single, cohesive management interface.",
					packIdApprentice:
						'Two-year work-study program developing features across the full Pack ID platform stack, from Android mobile to server APIs.',
					packIdMigration:
						'Led technical modernization of Pack ID, a mobile badge and access management system serving 100,000+ users. Migrated from legacy VM infrastructure to cloud-native architecture.',
				},
				externalLink: 'View product',
				highlight: {
					liveIntelligence: {
						h1: 'Architecting unified user management system replacing multiple separate admin interfaces',
						h2: 'Serving hundreds to thousands of enterprise users across multiple modules',
						h3: 'Progressing to Lead Developer in a team of 10 developers',
						h4: 'Delivered features across backend APIs, web frontend and Keycloak',
						h5: 'Created custom Keycloak theme using Keycloakify for branded authentication experience',
					},
					packIdApprentice: {
						h1: 'Developed website pages, REST APIs, and Android application screens',
						h2: 'Grew from junior to autonomous developer over 2-year program',
						h3: 'Mentored incoming apprentice, transferring product knowledge',
					},
					packIdMigration: {
						h1: 'Migrated legacy Java/Spring Boot 1 stack to modern Kotlin/Spring Boot 3 on Azure',
						h2: 'Refactored to stateless architecture with Redis session management',
						h3: 'Enabled faster deployments and improved observability across the stack',
						h4: 'Delivered features across backend APIs, web frontend, and mobile app',
					},
				},
				period: {
					liveIntelligence: 'Jan 2025 — Present',
					packIdApprentice: 'Oct 2019 — Nov 2021',
					packIdMigration: 'Dec 2023 — Jan 2025',
				},
				project: {
					liveIntelligence: 'Live Intelligence',
					packId: 'Pack ID',
					packIdMigration: 'Pack ID Migration',
				},
				role: {
					apprentice: 'Developer Apprentice',
					fullstack: 'Full-Stack Developer',
				},
				timeline: {
					ariaLabel: 'Experience timeline',
				},
				title: 'Experience',
			},
			home: {
				ariaLabel: 'Introduction',
				descriptionEnd: '.',
				descriptionStart:
					"As a Lead Developer, I drive decisions across the full stack while staying deeply invested in the craft—building exceptional digital products. Currently, I'm focused on building AI products at",
				name: 'Thomas GHIZZARDI.',
				tagline: 'Design. Code. Ship.',
			},
			projects: {
				ariaLabel: 'Projects',
				placeholder: 'Projects section coming soon...',
				title: 'Projects',
			},
			skills: {
				ariaLabel: 'Skills and expertise',
				card: {
					code: {
						description:
							'Building scalable, cloud-native applications that solve real problems with clean code.',
						example1: 'Designing cloud-ready, container-native architectures',
						example2: 'Documenting APIs with clear OpenAPI specifications',
						example3: 'Enforcing quality with linters, tests, and SonarQube',
						showcaseAlt: 'Microservices architecture diagram',
						title: 'Code with Purpose',
					},
					deploy: {
						description:
							'Delivering secure, portable deployments with automated pipelines and GitOps.',
						example1: 'Choosing Kubernetes for cloud-agnostic portability',
						example2: 'Embracing GitOps for auditable, declarative deployments',
						example3: 'Automating builds, tests, and releases through CI/CD',
						showcaseAlt: 'GitOps deployment pipeline diagram',
						title: 'Ship with Confidence',
					},
					design: {
						description:
							'Creating accessible, intuitive interfaces where user experience drives every decision.',
						example1: 'Prototyping user flows before writing any code',
						example2: 'Prioritizing accessibility and inclusive design',
						example3: 'Creating consistent design systems with clear tokens',
						showcaseAlt: 'Design system components in Figma',
						title: 'Design with Intent',
					},
				},
				category: {
					backend: 'Backend',
					deployment: 'Deployment',
					frontend: 'Frontend',
				},
				technologies: 'Technologies',
				title: {
					v1: 'Skills',
					v4: 'Skills',
				},
			},
		},
	},
}
